// src/components/Header.jsx
import React, { useEffect, useState } from "react";
import { me } from "../Admin/adminApi";
import AdminHeader from "./AdminHeader";
import CustomerHeader from "./CustomerHeader";
import {
  APP_MODES,
  clearStoredAppMode,
  getEffectiveAppMode,
  setStoredAppMode,
} from "../utils/appMode";

export default function Header() {
  const token = localStorage.getItem("token");
  const [user, setUser] = useState(null);
  const [mode, setMode] = useState(APP_MODES.CUSTOMER);
  const [loadingUser, setLoadingUser] = useState(!!token);

  useEffect(() => {
    let ok = true;

    (async () => {
      if (!token) {
        if (ok) {
          setUser(null);
          setMode(APP_MODES.CUSTOMER);
          setLoadingUser(false);
          clearStoredAppMode();
        }
        return;
      }

      try {
        const u = await me(token);

        if (!ok) return;

        setUser(u);
        setMode(getEffectiveAppMode(u));
      } catch {
        if (!ok) return;

        setUser(null);
        setMode(APP_MODES.CUSTOMER);
        clearStoredAppMode();
      } finally {
        if (ok) setLoadingUser(false);
      }
    })();

    return () => {
      ok = false;
    };
  }, [token]);

  const isAdmin = String(user?.role || "").toLowerCase() === "admin";

  const handleChangeMode = (nextMode) => {
    if (!isAdmin) return;

    const safeMode =
      nextMode === APP_MODES.ADMIN ? APP_MODES.ADMIN : APP_MODES.CUSTOMER;

    setMode(safeMode);
    setStoredAppMode(safeMode);
  };

  if (loadingUser && token) {
    return null;
  }

  if (isAdmin && mode === APP_MODES.ADMIN) {
    return (
      <AdminHeader user={user} mode={mode} onChangeMode={handleChangeMode} />
    );
  }

  return (
    <CustomerHeader user={user} mode={mode} onChangeMode={handleChangeMode} />
  );
}
